import React, { Fragment } from "react";
import { selectPermittedActions } from "../ui/permittedActionsReducer";
import { useSelector } from "react-redux";

const UiAction = (props) => {
  const permittedActions = useSelector(selectPermittedActions);
  return (
    <Fragment>
      {(props.editMode || permittedActions.permittedActions.indexOf(props.uiAction.actionName) !== -1) &&
        props.children}
    </Fragment>
  );
};

export default UiAction;
